export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  delta: string;
  firstSource: string;
  leadMin: number;
  time: string;
}

export interface NewsItem {
  id: number;
  tag: string;
  title: string;
  excerpt: string;
  firstSource: string;
  ago: string;
  hot: number;
  img: string;
}

export interface PlatformRow {
  name: string;
  delay: string;
  depth: number;
  update: string;
  score: number;
  desc: string;
}

export interface TopicItem {
  name: string;
  count: number;
  img: string;
  desc: string;
}

export interface ReviewItem {
  id: number;
  tag: string;
  title: string;
  excerpt: string;
  minutes: string;
  score: string;
  img: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const navLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '抢先首发', href: '#breaking' },
  { label: '速度排行', href: '#speed' },
  { label: '主题盘点', href: '#topics' },
  { label: '深度测评', href: '#picks' },
  { label: '吃瓜口碑', href: '#reviews' },
  { label: '常见问题', href: '#faq' },
];

export const heroStats = [
  { value: '180+', label: '全网平台覆盖' },
  { value: '分钟级', label: '更新时效' },
  { value: '98%', label: '抢先首发率' },
  { value: '40万+', label: '每日阅读' },
];

export const tickerItems = [
  '热度第一 · 某顶流工作室深夜发声明 全网仅用 9 分钟传开',
  '抢先 3 分钟 · 音乐盛典获奖名单首发复盘已上线',
  '热播综艺花絮片段提前流出 24 分钟 网友直呼刺激',
  '某新剧定档消息 微博首发领先图文社区 11 分钟',
  '品牌联名预告被扒出 视频平台速度居首',
];

export const hotList: HotItem[] = [
  { rank: 1, title: '顶流演唱会门票秒空，粉丝抢票崩溃实录刷屏', tag: '娱乐', heat: 98, delta: '较昨日 +12%', firstSource: '短视频热榜', leadMin: 6, time: '2 分钟前' },
  { rank: 2, title: '热播剧大结局被提前剧透，片方紧急回应', tag: '影视', heat: 95, delta: '较昨日 +9%', firstSource: '社交热搜', leadMin: 4, time: '5 分钟前' },
  { rank: 3, title: '综艺嘉宾路透照流出，CP 同框引热议', tag: '综艺', heat: 90, delta: '较昨日 +15%', firstSource: '图文社区', leadMin: 11, time: '8 分钟前' },
  { rank: 4, title: '新专辑概念宣传片曝光，风格大变引猜疑', tag: '音乐', heat: 87, delta: '较昨日 +6%', firstSource: '弹幕视频', leadMin: 9, time: '12 分钟前' },
  { rank: 5, title: '某品牌全球代言人官宣前 1 小时被提前扒出', tag: '品牌', heat: 84, delta: '较昨日 -3%', firstSource: '社交热搜', leadMin: 58, time: '16 分钟前' },
  { rank: 6, title: '网红翻车事件持续发酵，多个账号紧急改名', tag: '网红', heat: 81, delta: '较昨日 +21%', firstSource: '图文社区', leadMin: 7, time: '22 分钟前' },
  { rank: 7, title: '选秀综艺复活赛名单流出，淘汰选手粉丝发力', tag: '综艺', heat: 78, delta: '较昨日 +4%', firstSource: '短视频热榜', leadMin: 5, time: '27 分钟前' },
  { rank: 8, title: '体育明星跨界综艺首秀，录制现场细节被扒', tag: '体育', heat: 73, delta: '较昨日 +8%', firstSource: '弹幕视频', leadMin: 13, time: '31 分钟前' },
];

export const breakingNews: NewsItem[] = [
  {
    id: 1, tag: '抢先首发', title: '音乐节首波阵容深夜官宣，我们比多数平台早 14 分钟同步',
    excerpt: '从官宣微博发布到全网转载，我们锁定首发时间点，第一时间整理完整阵容与购票信息，避免瓜友错过开票。',
    firstSource: '微博首发', ago: '3 分钟前', hot: 96,
    img: 'https://readdy.ai/api/search-image?query=festival%20stage%20with%20vivid%20warm%20lights%20and%20confetti%2C%20energetic%20crowd%20silhouettes%2C%20editorial%20newsroom%20photo%20style%2C%20orange%20and%20cream%20tones%2C%20soft%20bokeh&width=800&height=520&seq=bg-bk-01&orientation=landscape',
  },
  {
    id: 2, tag: '抢先首发', title: '剧集预告片提前流出，弹幕区已成大型解谜现场',
    excerpt: '预告隐藏彩蛋被网友逐帧分析，我们汇总弹幕与评论区线索，整理出完整时间线解析，抢先整理成文。',
    firstSource: '弹幕视频首发', ago: '8 分钟前', hot: 91,
    img: 'https://readdy.ai/api/search-image?query=cinematic%20film%20set%20with%20director%20chair%20and%20clapperboard%2C%20warm%20studio%20lighting%2C%20editorial%20behind%20the%20scenes%20photography%2C%20cream%20and%20terracotta%20palette&width=800&height=520&seq=bg-bk-02&orientation=landscape',
  },
  {
    id: 3, tag: '全网热度', title: '联名新品路透照流出，配色与发售时间全被扒',
    excerpt: '从图库缓存到商家后台字段，网友硬核挖出关键信息。我们快速核对信源并标出可信度，帮大家理性吃瓜。',
    firstSource: '图文社区首发', ago: '13 分钟前', hot: 85,
    img: 'https://readdy.ai/api/search-image?query=minimalist%20product%20packaging%20teaser%20shot%20on%20warm%20backdrop%2C%20sneakers%20and%20poster%2C%20editorial%20studio%20photography%2C%20amber%20and%20cream%20tones&width=800&height=520&seq=bg-bk-03&orientation=landscape',
  },
  {
    id: 4, tag: '全网热度', title: '综艺花絮里一句话被放大，弹幕考古现场失控',
    excerpt: '一句看似无心的话引发全平台考古，我们梳理前因后果与各方回应，形成客观时间轴供瓜友判断。',
    firstSource: '弹幕视频首发', ago: '18 分钟前', hot: 80,
    img: 'https://readdy.ai/api/search-image?query=studio%20set%20with%20ring%20lights%20and%20cameras%2C%20warm%20interview%20lighting%2C%20editorial%20tv%20production%20photography%2C%20cream%20and%20coral%20palette&width=800&height=520&seq=bg-bk-04&orientation=landscape',
  },
];

export const platformRows: PlatformRow[] = [
  { name: '短视频热榜', delay: '3-8 分钟', depth: 82, update: '5 分钟/轮', score: 96, desc: '传播最快，片段式爆料为主，适合抢首波热度。' },
  { name: '社交热搜', delay: '5-12 分钟', depth: 88, update: '10 分钟/轮', score: 94, desc: '话题聚合能力强，热搜词更新频繁，讨论量大。' },
  { name: '图文社区', delay: '8-20 分钟', depth: 93, update: '15 分钟/轮', score: 91, desc: '图文长文居多，适合深度梳理与背景考古。' },
  { name: '弹幕视频', delay: '10-25 分钟', depth: 90, update: '不定时', score: 88, desc: '实况转播与二次创作并存，热门事件更新不规律。' },
  { name: '综合资讯', delay: '15-40 分钟', depth: 84, update: '30 分钟/轮', score: 82, desc: '偏新闻稿体，求稳为主，首发速度相对靠后。' },
];

export const topicList: TopicItem[] = [
  {
    name: '娱乐八卦', count: 1286, desc: '明星动态与圈内热点速递',
    img: 'https://readdy.ai/api/search-image?query=glamorous%20stage%20backdrop%20with%20spotlights%20and%20confetti%2C%20warm%20orange%20glow%2C%20editorial%20entertainment%20photography%2C%20cream%20palette&width=600&height=460&seq=topic-ent&orientation=squarish',
  },
  {
    name: '影视综漫', count: 954, desc: '剧集综艺与新片速报',
    img: 'https://readdy.ai/api/search-image?query=film%20reel%20and%20popcorn%20on%20warm%20background%2C%20cinema%20atmosphere%2C%20editorial%20photography%2C%20amber%20tones&width=600&height=460&seq=topic-film&orientation=squarish',
  },
  {
    name: '音乐盛典', count: 621, desc: '榜单发布与舞台名场面',
    img: 'https://readdy.ai/api/search-image?query=music%20notes%20and%20vinyl%20records%20artistic%20flat%20lay%2C%20warm%20lighting%2C%20editorial%20photography%2C%20cream%20and%20coral&width=600&height=460&seq=topic-music&orientation=squarish',
  },
  {
    name: '品牌风向', count: 437, desc: '代言合作与新品风向标',
    img: 'https://readdy.ai/api/search-image?query=modern%20brand%20campaign%20moodboard%20with%20packaging%20and%20posters%2C%20warm%20studio%20light%2C%20editorial%20style%2C%20terracotta%20tones&width=600&height=460&seq=topic-brand&orientation=squarish',
  },
  {
    name: '网红生态', count: 382, desc: '达人动态与圈层观察',
    img: 'https://readdy.ai/api/search-image?query=phone%20screen%20with%20social%20icons%20on%20warm%20desk%2C%20soft%20lighting%2C%20editorial%20photography%2C%20cream%20and%20amber%20palette&width=600&height=460&seq=topic-net&orientation=squarish',
  },
  {
    name: '科技新潮', count: 298, desc: '新品爆料与硬核评测',
    img: 'https://readdy.ai/api/search-image?query=futuristic%20gadget%20on%20warm%20minimal%20surface%2C%20soft%20studio%20light%2C%20editorial%20product%20photography%2C%20cream%20palette&width=600&height=460&seq=topic-tech&orientation=squarish',
  },
];

export const reviewList: ReviewItem[] = [
  {
    id: 1, tag: '速度评测', title: '五大平台首发实测：谁在真正意义的“第一时间”？',
    excerpt: '我们连续 72 小时跟测多起热点，用分钟级计时还原各大平台的真实传播链路，为你挑出追瓜最快的入口。',
    minutes: '6 分钟读完', score: '9.4 分', img: 'https://readdy.ai/api/search-image?query=stopwatch%20and%20news%20timeline%20on%20warm%20desk%2C%20editorial%20concept%20photography%2C%20cream%20and%20orange%20tones&width=640&height=420&seq=rev-01&orientation=landscape',
  },
  {
    id: 2, tag: '时效比拼', title: '突发瓜：短视频 vs 图文社区，谁快谁能全？',
    excerpt: '同一事件在两端的呈现差异巨大，一个抢快一个补全。我们横向对比各自的抢先时间与信息完整度。',
    minutes: '5 分钟读完', score: '9.1 分', img: 'https://readdy.ai/api/search-image?query=two%20smartphones%20side%20by%20side%20with%20news%20apps%2C%20warm%20desk%20lighting%2C%20editorial%20comparison%20photography%2C%20amber%20tones&width=640&height=420&seq=rev-02&orientation=landscape',
  },
  {
    id: 3, tag: '深度盘点', title: '从路透到实锤：一张图看懂热点的“标准化流程”',
    excerpt: '路透、官宣、实锤、反转……我们拆解每个热点必经的传播节点，帮你判断信息真实度，少交智商税。',
    minutes: '8 分钟读完', score: '9.0 分', img: 'https://readdy.ai/api/search-image?query=flowchart%20diagram%20on%20warm%20table%20with%20pen%2C%20editorial%20explainer%20photography%2C%20cream%20and%20coral%20tones&width=640&height=420&seq=rev-03&orientation=landscape',
  },
];

export const faqList: FaqItem[] = [
  {
    q: '吃瓜最快如何保证首发时效？',
    a: '我们部署了跨平台实时监听与多源交叉核验机制，一旦监测到话题热度快速上升，会优先整理信源、标记可信度并抢先成文，同时给出各平台的首发时间对照，帮助你判断信息的优先级。',
  },
  {
    q: '“速度排行”的数据是怎么算出来的？',
    a: '速度排行综合了首发延迟、传播速度、更新轮次与信源完整度四个维度。我们会以同一热点在不同平台的落地时间差作为核心指标，并结合平台热度权重综合打分，尽量避免只比谁发得快、不顾内容深度的问题。',
  },
  {
    q: '这里的信息都经过核实吗？',
    a: '我们会对每条内容标注信源与可信度等级，路透类信息会明确提示“未经证实”，仅有官宣或多方交叉验证的信息才会标记为“实锤”。追瓜再快，也绝不把猜测当成事实。',
  },
  {
    q: '平台内容实时刷新，会不会漏掉重要进展？',
    a: '重要热点会进入持续追踪队列，一旦有阶段性的新进展（如新回应、新证据、反转），我们会以“进展更新”的方式补充到原报道中，并重置时间标签，避免你错过关键变化。',
  },
  {
    q: '如何第一时间收到我关注主题的更新？',
    a: '你可以在页面底部订阅“第一时间推送”，选择关注的栏目后，我们会在相关主题出现热度上升或重要进展时，通过邮件第一时间通知你，不错过任何关键节点。',
  },
];

export const brands = [
  { icon: 'ri-flashlight-fill', name: '分钟级抢先', desc: '热点上升即触发，第一时间锁定首发窗口。' },
  { icon: 'ri-scales-3-fill', name: '跨平台对比', desc: '多源交叉核验，速度与深度双向把关。' },
  { icon: 'ri-list-check-3', name: '可信度分级', desc: '路透、实锤、反转清晰标注，理性追瓜。' },
  { icon: 'ri-focus-3-fill', name: '主题持续追踪', desc: '重要事件实时补更，关键进展不遗漏。' },
];

export const categories = [
  '娱乐', '影视', '综艺', '音乐', '品牌', '网红', '体育', '科技', '时尚', '社会',
];